const DATE_FILTERS = [
  { key: "week", label: { ko: "1주일", en: "1W", es: "1S" } },
  { key: "months", label: { ko: "1개월", en: "1M", es: "1M" } },
  { key: "3months", label: { ko: "3개월", en: "3M", es: "3M" } },
  { key: "6months", label: { ko: "6개월", en: "6M", es: "6M" } },
  { key: "years", label: { ko: "1년", en: "1Y", es: "1A" } }
]

export const leakChartBundle = {
  title: { ko: "시간당 물 사용량", en: "Hourly Water Usage", es: "Consumo de agua por hora" },
  leakStartTimeFilter: {
    key: "leakStartTime",
    label: { ko: "누수시작시점", en: "Leak Start Time", es: "Hora de inicio de fuga" }
  },
  dateFilters: DATE_FILTERS,
  filter: {
    periodSettings: { ko: "기간 설정", en: "Period Settings", es: "Configuración de periodo" },
    startDate: { ko: "시작일", en: "Start Date", es: "Fecha de inicio" },
    endDate: { ko: "종료일", en: "End Date", es: "Fecha de finalización" }
  },
  noSelectionMessage: {
    ko: "동 호수 선택 시 기간이 나타납니다.\n",
    en: "Select a unit to view the period.\n",
    es: "Seleccione una unidad para ver el periodo.\n"
  },
  customRangeLabel: {
    ko: "직접 설정",
    en: "Custom Range",
    es: "Rango personalizado"
  },
  time: { ko: "시", en: "H", es: "H" },
  search: { ko: "검색", en: "Search", es: "Buscar" },
  info: {
    period: { ko: "기간", en: "Period", es: "Periodo" },
    usage: { ko: "사용량", en: "Usage", es: "Consumo" },
    leakAmount: { ko: "누수량", en: "Leak Volume", es: "Volumen de fuga" },
    leakRate: { ko: "누수율", en: "Leak Rate" },
    leakStartTime: { ko: "누수시작시점", en: "Leak Start Time" },
    leakType: { ko: "누수 유형", en: "Leak Type" }
  }
}
